import { render } from "./CheckoutContainerShipments.vue?vue&type=template&id=4355dbeb"
import script from "./CheckoutContainerShipments.vue?vue&type=script&lang=js"
export * from "./CheckoutContainerShipments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__